<template>
  <el-menu
    :active="activeIndex"
    class="el-menu-demo"
    id="main_header"
    mode="horizontal"
    @select="handleSelect"
    text-color="#fff"
    active-text-color="#ffd04b">
    <img src="../assets/images/logitembus_logo.jpg" alt="" style="float: left;" height="100%" width="99">
    <el-submenu v-if="adminLoggedInfo.role == 3" index="2">
      <template slot="title">{{ $t("menu.parent_and_student") }}</template>
      <el-menu-item index="2-1">{{ $t("menu.parent_list") }}</el-menu-item>
      <el-menu-item index="2-2">{{ $t('menu.student_list') }}</el-menu-item>
      <el-menu-item index="2-3">{{ $t('menu.class_list') }}</el-menu-item>
      <el-menu-item index="2-4">{{ $t('grade.titleList') }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" index="5">
      <template slot="title">{{ $t('menu.bus_and_driver') }}</template>
      <el-menu-item index="5-3">{{ $t('menu.bus') }}</el-menu-item>
      <el-menu-item index="5-1">{{ $t('menu.driver') }}</el-menu-item>
      <el-menu-item index="5-2">{{ $t('menu.sub_driver') }}</el-menu-item>
      <el-menu-item index="5-4">{{ $t('menu.bus_history') }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" index="3">
      <template slot="title">{{ $t('menu.route') }}</template>
      <el-menu-item index="3-1">{{ $t('menu.bus_stop') }}</el-menu-item>
      <el-menu-item index="3-2">{{ $t('menu.pickup_route') }}</el-menu-item>
      <el-menu-item index="3-3">{{ $t('menu.drop_route') }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" index="9">
      <template slot="title">{{ $t('menu.schedule') }}</template>
      <el-menu-item index="9-1">{{ $t('menu.schedule') }}</el-menu-item>
      <el-menu-item index="9-2">{{ $t('menu.schedule_template_list') }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" index="1">
      <template slot="title">{{ $t('menu.notification') }}</template>
      <el-menu-item index="1-5">{{ $t('menu.send_notification') }}</el-menu-item>
      <el-menu-item index="1-6">{{ $t('menu.notification_list') }}</el-menu-item>
      <el-menu-item index="1-1">{{ $t('menu.admin_notification_template') }}</el-menu-item>
      <el-menu-item index="1-2">{{ $t('menu.parent_notification_template') }}</el-menu-item>
      <el-menu-item index="1-3">{{ $t('menu.bus_notification_template') }}</el-menu-item>
      <el-menu-item index="1-4">{{ $t('menu.notification_group') }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" id="" index="8">
      <template slot="title">
        {{ $t('menu.received_notification') }}
        <span class="notification-badge" v-if="countUnread.total">{{ countUnread.total }}</span>
      </template>
      <el-menu-item index="8-1">
        {{ $t('menu.parent_profile_change_list') }}
        <span class="notification-badge" v-if="countUnread.parentUpdateHistory">{{ countUnread.parentUpdateHistory }}</span>
      </el-menu-item>
      <el-menu-item index="8-2">
        {{ $t('menu.parent_notification') }}
        <span class="notification-badge" v-if="countUnread.parentNotification">{{ countUnread.parentNotification }}</span>
      </el-menu-item>
      <el-menu-item index="8-3">
        {{ $t('menu.bus_notification') }}
        <span class="notification-badge" v-if="countUnread.busNotification">{{ countUnread.busNotification }}</span>
      </el-menu-item>
      <el-menu-item index="8-4">
        {{ $t('menu.cancel_history') }}
        <span class="notification-badge" v-if="countUnread.cancel">{{ countUnread.cancel }}</span>
      </el-menu-item>
      <el-menu-item index="8-5">
        {{ $t('menu.authorized_person_notification') }}
        <span class="notification-badge" v-if="countUnread.authorizedPerson">{{ countUnread.authorizedPerson }}</span>
      </el-menu-item>
      <el-menu-item index="8-6">
        {{ $t('parent_list.parent_list_approve') }}
        <span class="notification-badge" v-if="countUnread.parentApprove">{{ countUnread.parentApprove }}</span>
      </el-menu-item>
      <el-menu-item index="8-7">
        {{ $t('titleListNewStudent') }}
        <span class="notification-badge" v-if="countUnread.parentApprove">{{ countUnread.newStudent }}</span>
      </el-menu-item>
    </el-submenu>
    <el-submenu v-if="adminLoggedInfo.role == 3" index="6">
      <template slot="title">{{ $t('menu.general') }}</template>
      <el-menu-item index="6-1">{{ $t('menu.change_school_info') }}</el-menu-item>
      <el-menu-item index="6-3">{{ $t('menu.administrator_list') }}</el-menu-item>
      <el-menu-item index="6-4">{{ $t('menu.file_list') }}</el-menu-item>
      <el-menu-item index="6-5">{{ $t('menu.day_off_list') }}</el-menu-item>
      <el-menu-item index="6-6">{{ $t('log.titleList') }}</el-menu-item>
      <el-menu-item index="6-7">{{ $t('termOfUser.menu') }}</el-menu-item>
    </el-submenu>
    <el-submenu  index="7">
      <template slot="title">{{ $t('menu.file_m_tab') }}</template>
      <el-menu-item index="7-1">{{ $t('menu.category_file_management') }}</el-menu-item>
      <el-menu-item index="7-2">{{ $t('menu.file_management') }}</el-menu-item>
    </el-submenu>
    <el-submenu id="user_login" index="4">
      <template slot="title" class="profile">{{getDisplayName()}}</template>
      <el-menu-item index="4-1" v-if="adminLoggedInfo.role == 3">{{ $t('common.profile') }}</el-menu-item>
      <el-menu-item index="4-3">{{ $t('common.logout') }}</el-menu-item>
    </el-submenu>
    <div id="profile_image" class="profile"></div>
  </el-menu>

</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "Header",
    data: function () {
      return {
        activeIndex: 1,
        adminDisplayName: '',
        isShow: true
      }
    },

    methods: {
      getDisplayName: function () {
        return this.adminLoggedInfo.role === 2
            ? this.adminLoggedInfo.user_info.name : this.adminLoggedInfo.user_info.display_name
      },
      handleSelect(key, keyPath) {
        if (key == '5-3') {
          this.$router.push('/bus');
        } else if (key == '2-1') {
          this.$router.push('/parent')
        } else if (key == '2-2') {
          this.$router.push('/student')
        } else if (key == '2-3') {
          this.$router.push('/classroom')
        } else if (key == '2-4') {
          this.$router.push('/grade-management')
        } else if (key == '5-1') {
          this.$router.push('/driver')
        } else if (key == '5-2') {
          this.$router.push('/sub-driver')
        } else if (key == '3-1') {
          this.$router.push('/place')
        } else if (key == '3-2') {
          this.$router.push('/pickup-route')
        } else if (key == '3-3') {
          this.$router.push('/drop-route')
        } else if (key == '1-1') {
          this.$router.push('/admin-notification-template')
        } else if (key == '1-2') {
          this.$router.push('/parent-notification-template')
        } else if (key == '1-3') {
          this.$router.push('/bus-notification-template')
        } else if (key == '1-4') {
          this.$router.push('/notification-group')
        } else if (key == '1-5') {
          this.$router.push('/notification/add')
        } else if (key === '1-6') {
          this.$router.push('/admin-notification')
        } else if (key == '6-1') {
          this.$router.push('/setting-school')
        } else if (key == '6-3') {
          this.$router.push('/admin')
        } else if (key == '6-2') {
          this.$router.push('/attachment')
        } else if (key == '7-1') {
          this.$router.push('/category-management')
        } else if (key == '7-2') {
          this.$router.push('/file-management')
        } else if (key == '7-3') {
          this.$i18n.locale = 'ja'
        } else if (key == '6-4') {
          this.$router.push('/attachment/file-user')
        } else if (key == '4-3') {
          this.logout()
        } else if (key == '4-1') {
          this.$router.push({path: '/admin/detail', query: {aid: localStorage.getItem('user_id')}});
        } else if (key === '8-1') {
          this.$router.push('/notification/parent-update-profile')
        } else if (key === '8-2') {
          this.$router.push('/notification/parent')
        } else if (key === '8-3') {
          this.$router.push('/notification/bus')
        } else if (key === '9-1') {
          this.$router.push('/schedule/detail')
        } else if (key === '9-2') {
          this.$router.push('/schedule/template-list')
        } else if (key === '8-4') {
          this.$router.push('/schedule/cancel')
        } else if (key === '8-5') {
          this.$router.push('/notification/authorized-person')
        } else if (key === '8-6') {
          this.$router.push('/list-parent-need-approve')
        } else if (key === '8-7') {
          this.$router.push('/notification/new-student')
        }else if (key === '5-4') {
          this.$router.push('/bus/history')
        } else if (key === '6-5') {
          this.$router.push('/general/day-off')
        }
        else if (key === '6-6') {
          this.$router.push('/log-management')
        }
        else if (key === '6-7') {
          this.$router.push('/term-of-user')
        }
      },
      logout: function () {
        let successCallback = () => {
          this.$router.push('/login')
        }
        let payload = {
          successCallback
        }
        this.$store.dispatch('login/adminLogout', payload)
      }
    },
    computed: {
      ...mapState('login', ['adminLoggedInfo', 'unreadNotificationList']),
      countUnread: function () {
        let parentNotification = 0
        let parentUpdateHistory = 0
        let busNotification = 0
        let cancel = 0
        let authorizedPerson = 0
        let parentApprove = 0
        let newStudent = 0
        if (this.unreadNotificationList.parentNotificationIds) {
          parentNotification = this.unreadNotificationList.parentNotificationIds.length
        }

        if (this.unreadNotificationList.parentUpdateHistoryIds) {
          parentUpdateHistory = this.unreadNotificationList.parentUpdateHistoryIds.length
        }

        if (this.unreadNotificationList.busNotificationIds) {
          busNotification = this.unreadNotificationList.busNotificationIds.length
        }

        if (this.unreadNotificationList.cancelIds) {
          cancel = this.unreadNotificationList.cancelIds.length
        }

        if (this.unreadNotificationList.authorizedPersonIds) {
          authorizedPerson = this.unreadNotificationList.authorizedPersonIds.length
        }
        if(this.unreadNotificationList.parentApproveIds){
          parentApprove = this.unreadNotificationList.parentApproveIds.length
        }
        if(this.unreadNotificationList.newStudentNoticeIds){
          newStudent = this.unreadNotificationList.newStudentNoticeIds.length
        }

        return {
          parentNotification,
          parentUpdateHistory,
          busNotification,
          cancel,
          authorizedPerson,
          parentApprove,
          newStudent,
          total: parentNotification + parentUpdateHistory + busNotification + cancel + authorizedPerson + parentApprove + newStudent
        }
      }
    },
    watch: {
      '$route'(to, from) {
        if (to.path.includes('/bus')) {
          this.activeIndex = 1
        }
        if (to.path.includes('/parent')) {
          this.activeIndex = 2
        }
      },
    }
  }
</script>

<style lang="scss">
  $XS: 768px;
  $SM: 768px;
  $MD: 992px;
  $LG: 1200px;
  $XL: 1920px;
  // media queries

  @mixin Responsive($canvas) {
    @if $canvas == XS {
      @media only screen and (max-width: $XS) { @content; }
    }
    @else if $canvas == SM {
      @media only screen and (min-width: $SM) and (max-width: $MD) { @content; }
    }
    @else if $canvas == MD {
      @media only screen and (min-width: $MD) { @content; }
    }
    @else if $canvas == LG {
      @media only screen and (min-width: $LG) { @content; }
    }
    @else if $canvas == XL {
      @media only screen and (min-width: $XL) { @content; }
    }
  }
  .input-title{
    @include Responsive(XL){
      width: 60%;
    }
    @include Responsive(LG){
      width: 50% !important;
    }
  }
  #main_header li {
    font-size: 20px;
    line-height: 100px;
    height: 100%;
    color: #fff !important
  }

  #main_header {
    background: #213F9A !important;
    height: 100px;
  }

  #main_header:hover {
    border-bottom: 0px !important;
  }

  #main_header li:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-bottom: 5px solid #fff !important;
  }

  #main_header li:focus {
    background-image: #213F9A !important;
    border-bottom: 5px solid #fff !important;
    color: #fff !important;
  }

  #main_header li:active {
    background-image: #213F9A !important;
    border-bottom: 5px solid #fff !important;
    color: #fff !important;
  }

  .el-submenu div {
    height: 100% !important;
    font-size: 17px !important;
    line-height: 100px !important;
    @include Responsive(MD){
      padding:0 8px;
    }
    @include Responsive(XL){
      padding: 0 20px;
    }
  }

  .el-submenu div:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-bottom: 2px solid #fff !important;
  }

  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    background-color: #213F9A !important;
    float: none;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    padding: 0 10px;
    color: #909399;
  }

  .el-menu--horizontal .el-menu {
    background-color: #213F9A !important;
  }

  .profile {
    background-image: url("../assets/images/logitembus_logo.jpg");
    width: 60px;
    height: 60px;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 60px;
    float: right;
    margin: 20px 10px 0 0;
  }

  #user_login {
    float: right;
  }

  .el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: transparent !important;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 5px solid #fff !important;
  }

  .el-menu {
    .notification-badge {
      display: inline-block;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      background: #ED1165;
      font-size: 10px;
      line-height: 25px;
      text-align: center;
    }
  }
</style>
